import {
  CHANGE_FILE,
  CHANGE_FILES,
  ADD_FILES
} from './actions'

export default function(state = {
  files: []
}, action) {
  switch(action.type) {
    case CHANGE_FILES:
      return { ...state, files: action.payload }
    case ADD_FILES:
      return { ...state, files: [...action.payload, ...state.files] }
    default:
      return state
  }
}
